













































import { POSAccessControlEvent } from '@pos/interfaces/pos-v2';
import PosAccessControlService from '@pos/services/pos-access-control-service';
import BpcTable from '@shared/components/tables/table.vue';

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component({
  name: 'bpc-pos-access-control-events',
  components: {
    BpcTable,
  },
})
export default class PosAccessControlEvents extends Vue {
  // PROPS
  @Prop({ type: Number, required: true }) readonly posSessionId: number;

  // DATA
  accessControlEvents: POSAccessControlEvent[] = [];
  loading = false;
  FieldsToShowInTable = [
    { key: 'event_type', headerLabel: 'pos.access_control_events.event_type.label' },
    {
      key: 'visit_count',
      headerLabel: 'pos.access_control_events.visit_count.label',
    },
    { key: 'event_date_time', headerLabel: 'pos.access_control_events.event_date_time.label' },
    {
      key: 'access_zone_description',
      headerLabel: 'pos.access_control_events.access_zone_description.label',
    },
    { key: 'contact_fullname', headerLabel: 'pos.access_control_events.contact_fullname.label' },
    { key: 'product_name', headerLabel: 'pos.access_control_events.product_name.label' },
    {
      key: 'access_control_badge_number',
      headerLabel: 'pos.access_control_events.access_control_badge_number.label',
    },
  ];

  //fill the row slot

  // COMPUTED
  get accessControlService(): PosAccessControlService {
    return this.$posService.accessControl;
  }
  // LIFE CYCLE
  mounted() {
    this.getAccessControlEvents();
    this.listenForAccessControlEventChanges();
  }

  listenForAccessControlEventChanges() {
    this.accessControlService
      .getAccessControlEventChangesChannel()
      .listen('.BPC\\AccessControl\\Events\\AccessControlEventCreated', async data => {
        // Add the event and remove the last one
        const accessControlEvents = [data.posAccessControlEvent, ...this.accessControlEvents];
        const MAX_SIZE = 50;

        if (accessControlEvents.length > MAX_SIZE) {
          this.accessControlEvents = accessControlEvents.slice(0, MAX_SIZE); // Devolver un nuevo array limitado al tamaño máximo
        } else {
          this.accessControlEvents = accessControlEvents;
        }
        console.log('AccessControlEventCreated', data);
      })
      .listen('.BPC\\AccessControl\\Events\\AccessControlEventEdited', async data => {
        console.log('AccessControlEventCreated', data);
      })
      .listen('.BPC\\AccessControl\\Events\\AccessControlEventDeleted', async data => {
        console.log('AccessControlEventCreated', data);
      });
  }
  // METHODS
  async getAccessControlEvents() {
    this.loading = true;
    const accessControlEvents = await this.accessControlService.getAccessControlEvents(
      this.posSessionId,
    );
    this.accessControlEvents = accessControlEvents;
    this.loading = false;
    console.log('accessControlEvents', accessControlEvents);
  }

  showFullTable() {
    console.log('showFullTable');
  }

  formatDate(date) {
    return moment
      .utc(date)
      .local()
      .format('DD/MM/YYYY HH:mm');
  }
  // WATCH
}
